export default "__VITE_ASSET__tVJtr0fz__"